import { useContext } from 'react';
import { Context } from './index';

const useBaseDomain = () => {
  const { baseDomain } = useContext(Context);
  return baseDomain;
};

export default useBaseDomain;
